import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import GlobalNavbarEN from '../../../components/feature/GlobalNavbarEN';
import VisionSection from './components/VisionSection';
import AssetsSection from './components/AssetsSection';
import MarketDominanceSection from './components/MarketDominanceSection';
import PartnershipTiers from './components/PartnershipTiers';
import ExecutiveInquirySection from './components/ExecutiveInquirySection';
import PartnershipFooter from './components/PartnershipFooter';

export default function PartnershipPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-black font-inter">
      <GlobalNavbarEN />
      <VisionSection />
      <AssetsSection />
      <MarketDominanceSection />
      <PartnershipTiers />
      <ExecutiveInquirySection />
      <PartnershipFooter />
    </div>
  );
}
